import React, { useState } from "react";
import { ChargingBASE_URL } from '../../Config';
import Swal from 'sweetalert2'; // Import SweetAlert2

const FakeDataUpload = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [status, setStatus] = useState("Sub"); // Default status
    const [isLoading, setIsLoading] = useState(false); // State to track loading status

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const handleStatusChange = (event) => {
        setStatus(event.target.value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!selectedFile) {
            Swal.fire({
                icon: 'warning',
                title: 'No file selected',
                text: 'Please select an Excel file to upload.',
            });
            return;
        }

        setIsLoading(true); // Start loading

        try {
            const formData = new FormData();
            formData.append("ExcelFile", selectedFile);
            formData.append("Status", status);

            const response = await fetch(`${ChargingBASE_URL}UploadFile`, {
                method: "POST",
                body: formData,
            });

            if (!response.ok) {
                throw new Error("File upload failed");
            }

            const result = await response.json();
            Swal.fire({
                icon: 'success',
                title: 'Upload Successful',
                text: result.message,
            });
        } catch (error) {
            console.error("Error uploading file:", error);
            Swal.fire({
                icon: 'error',
                title: 'Upload Failed',
                text: 'An error occurred while uploading the file. Please try again.' ,error,
            });
        } finally {
            setIsLoading(false); // Stop loading
        }
    };

    return (
        <div className="container mt-4">
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-4">
                        {/* File Upload */}
                        <div className="mb-3">
                            <input
                                type="file"
                                className="form-control"
                                accept=".xlsx, .xls"
                                onChange={handleFileChange}
                                required
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        {/* Status Dropdown */}
                        <div className="mb-3">
                            <select
                                className="form-select"
                                value={status}
                                onChange={handleStatusChange}
                                required
                            >
                                <option value="Sub">Sub</option>
                                <option value="Reversed">Reversed</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-md-4">
                        {/* Submit Button */}
                        <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
                            {isLoading ? (
                                <div className="spinner-border text-light" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            ) : (
                                'Upload File'
                            )}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default FakeDataUpload;
